import React from 'react';
import T from "i18n-react";

const PageNotFound = () => {
  return (
    <h1>
      {T.translate("function.pageNotFound")}
    </h1>
  )
}

export default PageNotFound
